import React from 'react';
import './App.css';
import { Form } from 'react-bootstrap';


class EditableLabelItem extends React.Component {
	constructor(props) {
        super(props);
        this.state = {
        	isEditing: false,        	
			text: '',
        };
        
        this.handleEdit = this.handleEdit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleEndEdit = this.handleEndEdit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        
    }

	handleEdit() {
    	if (this.props.isEnabled){
	    	this.setState({
	    		isEditing:true,
	    		text:this.props.title,
	    	});
    	}
    }

	handleEndEdit(){
		if (this.props.isEnabled){
			this.setState({
	    		isEditing:false,
	    	},this.props.onTitleChanged(this.state.text));    	
	    	
		}
	}

	handleKeyPress(target){
		target.persist();
		if (target.charCode === 13){
	    	this.setState({
    	    	isEditing: false,
	        },this.props.onTitleChanged(this.state.text));
	    }
	    console.log(target.charCode)
	}

    handleChange(event) {
		this.setState({
	    	text: event.target.value,
	    });
    }


	render(){
		
			let retV = <div />;

			if(this.state.isEditing && this.props.isEnabled) {
				retV = 
					<Form.Control type="text" 
							value={this.state.text} 
							onChange={(e)=>this.handleChange(e)}
                    		onBlur={this.handleEndEdit}
                    		autoFocus 
                    		maxLength="50"
                    		style={{"width":"100%"}} onKeyPress={this.handleKeyPress}/>
			}else{
				retV = <label onClick={this.handleEdit}>{this.props.title}</label>
			}

		return(
			<div className="logo mx-auto">                        
				{retV}
            </div>			
		)	
		
	}
}
export default EditableLabelItem;